import { createFileRoute } from '@tanstack/react-router';

import { ResearchPage } from '@/features/research/ResearchPage';
import { isMarket, type Market } from '@/lib/market/types';

/** `/:market/research` —— 內部研究（白名單）。無權限時頁面自己畫「找不到」。 */
export const Route = createFileRoute('/$market/research')({
  component: ResearchRoute,
});

function ResearchRoute() {
  const { market: rawMarket } = Route.useParams();
  const market: Market = isMarket(rawMarket) ? rawMarket : 'tw';
  return <ResearchPage market={market} />;
}
